document.addEventListener("DOMContentLoaded", function () {
const checkoutButton = document.getElementById("checkout-submit-button");
if (!checkoutButton) return; // 13.10.2026: no cart checkout button on this page (e.g. product pages) - nothing to check; was a TypeError on parentNode
const warningMessage = document.createElement("p");
warningMessage.textContent = "Minimum cart total amount is £300.";
warningMessage.style.color = "red";
warningMessage.style.display = "none";
warningMessage.style.marginBottom = "0"; // Прибираємо відступ знизу

checkoutButton.parentNode.insertBefore(warningMessage, checkoutButton);

// Створюємо індикатор завантаження
const loadingSpinner = document.createElement("div");
loadingSpinner.id = "loading-spinner";
loadingSpinner.style.display = "none";
loadingSpinner.style.position = "fixed";
loadingSpinner.style.top = "50%";
loadingSpinner.style.left = "50%";
loadingSpinner.style.transform = "translate(-50%, -50%)";
loadingSpinner.style.zIndex = "1000";
loadingSpinner.innerHTML = '<div class="spinner"></div>';
document.body.appendChild(loadingSpinner);

// Додаємо стилі для крутилки
const spinnerStyle = document.createElement("style");
spinnerStyle.innerHTML = `
.spinner {
border: 16px solid #f3f3f3;
border-top: 16px solid #3498db;
border-radius: 50%;
width: 120px;
height: 120px;
animation: spin 2s linear infinite;
}

@keyframes spin {
0% { transform: rotate(0deg); }
100% { transform: rotate(360deg); }
}
`;
document.head.appendChild(spinnerStyle);

function showLoadingSpinner() {
loadingSpinner.style.display = "block";
}

function hideLoadingSpinner() {
loadingSpinner.style.display = "none";
}

function checkMinimumOrderAmount() {
fetch("/cart.js")
.then(response => response.json())
.then(cart => {
const totalAmount = cart.total_price / 100; // Отримуємо суму в фунтах
console.log("Total cart amount:", totalAmount);
const allowedProducts = ["EcoTherm Eco-Cavity", "Plasterboard", "MDF Boards", "Plywood", "Pine and Oak Wood", "MFC", "Ironmongery"];
const allowedProduct = cart.items.some(item => allowedProducts.includes(item.product_type));

if (allowedProduct && totalAmount < 300) {
// Якщо сума менша за 300 фунтів
checkoutButton.disabled = true;
warningMessage.style.display = "block";
} else {
// Якщо сума більша або дорівнює 300 фунтів
checkoutButton.disabled = false;
warningMessage.style.display = "none";
}
})
.catch(error => {
console.error("Error fetching cart data:", error);
});
}

function refreshCartPage() {
showLoadingSpinner();
setTimeout(function() {
window.location.reload();
}, 1000); // Затримка для завершення оновлення кошика
}

// Викликати функцію перевірки під час завантаження сторінки
checkMinimumOrderAmount();

// Додати прослуховувачі подій для кнопок збільшення та зменшення кількості товарів
document.querySelectorAll("quantity-input-plus, quantity-input-minus").forEach(button => {
button.addEventListener("click", function () {
checkMinimumOrderAmount();
setTimeout(refreshCartPage, 500); // Затримка перед оновленням сторінки
});
});

// Викликаємо функцію при завантаженні сторінки та при зміні кошика
document.addEventListener('DOMContentLoaded', checkMinimumOrderAmount);
document.addEventListener('cart:updated', function () {
checkMinimumOrderAmount();
refreshCartPage();
});
});